import userStore from '@/stores/user/index';

// 获取 recommender_ui_optimisation 实验组
const getRecommenderUIOptimisationGroup = () => {
  const controlGroup = (userStore.newABTestingConfigs as any)?.recommender_ui_optimisation;
  if (controlGroup === 'test') {
    return true;
  } else {
    return false;
  }
};

export default getRecommenderUIOptimisationGroup;
